import { HttpClient } from '@/components/shared/http-client'
import store from '@/store/store'
function generateApiUrl(accountCode) {
  return `/api/accounts/${accountCode}/tasks`
}

async function setAccountTasks(tasks) {
  await store.dispatch('setAccountTasks', tasks)
}
export async function addUserTask(accountCode, task) {
  const url = generateApiUrl(accountCode)
  try {
    const { data } = await HttpClient.post(url, task)
    await setAccountTasks(data)
  } catch (error) {
    console.error(error)
    throw error
  }
}

export async function addInsuredUserTask(accountCode, task) {
  const url = `${generateApiUrl(accountCode)}/insured`
  try {
    const { data } = await HttpClient.post(url, task)
    await setAccountTasks(data)
  } catch (error) {
    console.error(error)
    throw error
  }
}

export async function updateUserTask(accountCode, task) {
  const url = generateApiUrl(accountCode)
  try {
    const { data } = await HttpClient.put(url, task)
    await setAccountTasks(data)
  } catch (error) {
    console.error(error)
    throw error
  }
}

export async function deleteUserTask(accountCode, taskId) {
  const url = `${generateApiUrl(accountCode)}/${taskId}`
  try {
    const { data } = await HttpClient.delete(url)
    await setAccountTasks(data)
  } catch (error) {
    console.error(error)
    throw error
  }
}
